import BaseService from "./BaseService";

export default {
    incomeStatement(filter) {
        var url = '/income-statement?';

        filter = filter.filter;

        if (filter.type) {
            url += 'report_type=' + filter.type + '&';
        }

        if (filter.year) {
            url += 'report_year=' + filter.year + '&';
        }

        if (filter.project_id) {
            url += 'report_project_id=' + filter.project_id + '&';
        }

        return BaseService.get(url);
    },
    netWorth(data) {
        return BaseService.post('/net-worth', data);
    },
    balanceSheet(filter) {
        let url = '/balance-sheet?';

        filter = filter.filter;

        if (filter.type) {
            url += 'report_type=' + filter.type + '&';
        }

        if (filter.year) {
            url += 'report_year=' + filter.year + '&';
        }

        if (filter.project_id) {
            url += 'report_project_id=' + filter.project_id + '&';
        }

        return BaseService.get(url);
    },
}